module.exports = __webpack_public_path__ + "img/pro_six_3.7865a69f.jpg";